import React from 'react';
import * as T from 'prop-types';
import { NOOP, commandState } from '../../constants';
import { SelectableListProps } from '../../AuPropTypes';
import FilterSelectableList from "./FilterSelectableList";

export default class CommandState extends React.Component {

  static propTypes = {
    defaultValue: SelectableListProps.defaultValue,
    containerRef: SelectableListProps.containerRef,
    selection: SelectableListProps.selection,
    sort: SelectableListProps.sort,
    multiSelect: T.bool,
    onChange: T.func,
    onInit: T.func
  }

  static defaultProps = {
    onChange: NOOP,
    onInit: NOOP,
    selection: []
  }

  commandStateItems = Object.keys(commandState).filter(value => !value.includes('QUEUED') && !value.includes('IN_PROGRESS')).map(value => ({
    displayId: `au.entity.state.${value}`, value
  }));

  render() {
    return (
      <FilterSelectableList
        containerRef={this.props.containerRef}
        items={this.commandStateItems}
        sort={this.props.sort}
        defaultValue={this.props.defaultValue}
        selection={this.props.selection}
        multiSelect={this.props.multiSelect}
        onChange={this.props.onChange}
        onInit={this.props.onInit}
      />
    );
  }
}
